import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { AccountFormComponent } from '../account-form/account-form.component';

@Component({
  selector: 'app-account-legal-form',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./account-legal-form.component.scss', '../../shared/base-form/base-form.component.scss']
})
export class AccountLegalFormComponent extends AccountFormComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'legal';
  }

  private _agentId: string;
  public get agentId(): string {
    return this._agentId;
  }
  @Input() public set agentId(v: string) {
    this._agentId = v;
    // this.formData['agent_id'] = v;
    this.changeValue('agent_id', v);
    this.fields.find(c => c.name === 'agent_id').disabled = true;
  }

  async valueChanged(e) {
    if (e.value) {
      switch (e.element.id) {
        case 'nationality':
          const fieldIdentificationNo = this.fields.find(fc => fc.name === 'identification_no');
          if (e.value !== 'IRN') {
            // this.formData['identification_type'] = 'GP';
            this.changeValue('identification_type', 'FD');
            fieldIdentificationNo.rules = [{ type: 'required' }];
          } else {
            // this.formData['identification_type'] = 'NI';
            this.changeValue('identification_type', 'NI');
            fieldIdentificationNo.rules = [{ type: 'required' }, { type: 'stringLength', min: 11, max: 11 }];
          }
          break;
        default:
          await super.valueChanged(e);
          break;
      }
    }
  }

  addUploadColumns(id: any) {
    super.addUploadColumns(id);
    if (!this.fields.find(c => c.name === 'legal_newspaper_pic')) {
      this.fields.push({
        name: 'legal_newspaper_pic',
        caption: this.translator.instant('LEGAL_NEWSPAPER_PIC'),
        editorType: 'dxFileUploader',
        type: {
          name: 'uploader'
        }
      });
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    if (!this.isEdit) {
      setTimeout(() => {
        this.changeValue('identification_type', 'NI');
      }, 100);
    } else if (!this.roles.includes('SALES_MNG')) {
      this.changeDisabled('identification_no', true)
    }
  }
}
